<div class="editor">
  <div style="display: flex; align-items: center; gap: 4px; flex-wrap: wrap;">
    <button [ngClass]="configMode == 'basic' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'basic'">
      <span>{{('cau_hinh_co_ban') | translate}}</span>
    </button>
  
    <button [ngClass]="configMode == 'advanced' ? 'ant-btn ant-btn-primary' : 'ant-btn'" class="d-flex align-items-center" (click)="configMode = 'advanced'">
      <span>{{('cau_hinh_nang_cao') | translate}}</span>
    </button>
  </div>
  <!-- Cấu hình cơ bản -->
  <ng-container *ngIf="configMode == 'basic'">
    <div style="margin-top: 10px">
      <app-text-format-config
      [device]="device"
      [objectChoosing]="objectChoosing"
      [class]="class"
      [config]="config"
      
      [staticdata]="staticdata"
      [textContentClass]="class['quantity-sold__content']"
      [textWrapperClass]="class['quantity-sold']"
      >
</app-text-format-config>
    </div>
  </ng-container>
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>
  <ng-container *ngIf="!isViewAll && configMode == 'advanced'">
    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <!-- Cấu hình tái sử dụng thiết kế-->
      
      <!-- CHỮ VÀ ĐỊNH DẠNG-->
      <li nz-submenu nzTitle="{{'chu_va_dinh_dang' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
        <div class="editor-field">
          <div class="editor-field-body">
            <!-- Lựa chọn hiển thị cho các thiết bị -->
            <app-hide-show-config
              [device]="device"
              [elementChoosing]="objectChoosing">
            </app-hide-show-config>
            <div class="field-row">
              <!-- Kiểu văn bản -->
              <div class="config-font" style="width:100%">
                <mat-form-field style="width:100%">
                  <mat-label>Kiểu văn bản</mat-label>
                  <mat-select [disabled]="class['quantity-sold__content--list-style']['list-style'] != 'none'"
                    [(ngModel)]="config['font-size']['title']" (ngModelChange)="handleSetTextStyle($event)">
                    <mat-option *ngFor="let item of text_style" [value]="item.name"
                      [style.font-size.px]="item.font">{{item.title}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>

            <app-text-format-config
                    [device]="device"
                    [objectChoosing]="objectChoosing"
                    [class]="class"
                    [config]="config"
                    
                    [staticdata]="staticdata"
                    [textContentClass]="class['quantity-sold__content']"
                    [textWrapperClass]="class['quantity-sold']"
                    >
            </app-text-format-config>
            <div class="field-row">
              <!-- Gradient -->
              <div class="config-font">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                  <p class="m-0" style="line-height:1.5">Đổ màu gradient <span style="font-size:13px">(đa sắc)</span>
                  </p>
                  <nz-switch [(ngModel)]="config['background-image'].gradient_check"
                    (ngModelChange)="handleSetGradientText()">
                  </nz-switch>
                </div>
                <div class="container-gradient" *ngIf="config['background-image'].gradient_check">
                  <div class="list-gradient">
                    <button class="btn-gradient"
                      *ngFor="let bgGradient of config['background-image']['gradient_arr_gradient']; let i = index"
                      (click)="deleteGradient(i)" [ngStyle]="{'backgroundColor': bgGradient}"
                      [disabled]="!config['background-image'].gradient_check">
                      <i class="delete-icon bi bi-x-circle"></i>
                    </button>
                  </div>
                  <p class="title-head">{{ 'them_mau' | translate }}</p>
                  <div class="container_add-gradient">
                    <button class="btn-add-gradient" nzTooltipTitle="{{ 'them_mau' | translate }}" nz-tooltip
                      [disabled]="!config['background-image'].gradient_check" (click)="openbgGradient()"
                      (blur)="addGradient()">
                      <input nz-input type="color" class="picking-gradient" id="input-gradient"
                        [(ngModel)]="config['background-image']['gradient_background_color']">
                      <span class="plus-icon" nz-icon nzType="plus" nzTheme="outline"></span>
                    </button>
                    <div class="slide_container-gradient">
                      <input type="range" min="1" max="100" [value]="config['background-image']['gradient_opacity']"
                        class="slider-gradient" (input)="getValueRangeBackgroundGradient($event)"
                        [disabled]="!config['background-image'].gradient_check"
                        [ngStyle]="{background: 'linear-gradient(to right, transparent,#2764EB,#EFE810), url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==)'}">
                    </div>
                    <div class="value-range">{{config['background-image']['gradient_opacity']}}%</div>
                  </div>
                  <p class="title-head">{{ 'huong_phoi_mau' | translate }}</p>
                  <button class="gradient-direction" *ngFor="let type of typeGradient" nz-tooltip
                    [nzTooltipTitle]="type.name" (click)="chooseOption(type, $event)"
                    [disabled]="!config['background-image'].gradient_check"
                    [style.background]="'linear-gradient('+ type.deg +', #2764EB, #EFE810)'"
                    [ngClass]="{ 'active': config['background-image']['gradient_direction'] === type.direction}">
                  </button>
                </div>
              </div>
              <!-- Kiểu danh sách đầu dòng, đánh số -->
              <div class="config-font">
                <p class="title" style="line-height:1.5">Kiểu danh sách đầu dòng, đánh số</p>
                <div class="font">
                  <!-- Disc -->
                  <button class="font-text-btn" title="ordered-list" nz-button [disabled]="config['curve']['isCurve']"
                    (click)="handleListStyle('disc')" [nzType]="
                      class['quantity-sold__content--list-style']['list-style'] === 'disc inside none'
                        ? 'primary'
                        : 'default' ">
                    <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
                  </button>
                  <!-- Decimal -->
                  <button class="font-text-btn" title="unordered-list" nz-button [disabled]="config['curve']['isCurve']"
                    (click)="handleListStyle('decimal')" [nzType]="
                    class['quantity-sold__content--list-style']['list-style'] === 'decimal inside none'
                      ? 'primary'
                      : 'default'">
                    <i nz-icon nzType="ordered-list" nzTheme="outline"></i>
                  </button>
                  <!-- Alpha -->
                  <button class="font-text-btn" title="alpha-list" nz-button [disabled]="config['curve']['isCurve']"
                    (click)="handleListStyle('upper-alpha')" [nzType]="
                    class['quantity-sold__content--list-style']['list-style'] === 'upper-alpha inside none'
                      ? 'primary'
                      : 'default'">
                    <i class="anticon anticon-ordered-list">
                      <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 1920 1920"
                        xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="M546.15 1603.617h1360v-120h-1360v120Zm0-1121.001h1360v-120h-1360v120Zm0 561h1360v-120h-1360v120ZM271.675 429.5 234.55 319.775c-2.75-6.967-5.683-15.171-8.8-24.613-3.117-9.441-6.233-19.662-9.35-30.662-2.75 11.183-5.683 21.542-8.8 31.075-3.117 9.533-6.05 17.783-8.8 24.75L161.95 429.5h109.725ZM419.35 582.675H347.3c-8.067 0-14.575-1.879-19.525-5.638-4.95-3.758-8.708-8.57-11.275-14.437l-23.65-69.85H140.5l-23.65 69.85c-2.017 5.133-5.637 9.762-10.862 13.887-5.226 4.126-11.688 6.188-19.388 6.188H14L169.1 182h95.15l155.1 400.675ZM230.325 1112.55c12.283 0 22.321-1.558 30.112-4.675 7.792-3.117 13.888-7.15 18.288-12.1 4.4-4.95 7.425-10.541 9.075-16.775a73.843 73.843 0 0 0 2.475-18.975c0-7.333-.963-13.933-2.887-19.8-1.925-5.866-5.226-10.816-9.9-14.85-4.676-4.034-10.863-7.15-18.563-9.35-7.7-2.2-17.416-3.3-29.15-3.3h-64.9v99.825h65.45Zm-65.45-260.975v99h48.4c10.267 0 19.525-.733 27.775-2.2s15.262-4.033 21.038-7.7c5.775-3.667 10.175-8.708 13.199-15.125 3.025-6.417 4.538-14.483 4.538-24.2 0-9.533-1.192-17.462-3.575-23.788-2.383-6.324-6.05-11.412-11-15.262-4.95-3.85-11.229-6.6-18.838-8.25-7.608-1.65-16.637-2.475-27.087-2.475h-54.45ZM219.325 782c27.684 0 51.242 2.567 70.675 7.7s35.292 12.375 47.575 21.725c12.283 9.35 21.221 20.716 26.813 34.1 5.591 13.384 8.387 28.325 8.387 44.825 0 8.983-1.283 17.646-3.85 25.987-2.567 8.342-6.6 16.134-12.1 23.375-5.5 7.242-12.558 13.888-21.175 19.938-8.616 6.05-18.975 11.275-31.075 15.675 26.4 6.417 45.925 16.775 58.575 31.075 12.65 14.301 18.975 32.816 18.975 55.55 0 17.05-3.3 32.909-9.9 47.575-6.6 14.667-16.271 27.454-29.012 38.362-12.742 10.909-28.463 19.434-47.163 25.575-18.7 6.142-40.058 9.213-64.075 9.213H71.925V782h147.4Zm126.65 847c2.2 0 4.4.412 6.6 1.238 2.2.825 4.308 2.246 6.325 4.262l36.85 38.775c-16.133 21.084-36.346 36.987-60.637 47.713-24.292 10.724-53.03 16.087-86.213 16.087-30.433 0-57.704-5.179-81.812-15.538-24.109-10.358-44.551-24.658-61.326-42.9-16.774-18.241-29.654-39.874-38.637-64.899-8.984-25.026-13.475-52.204-13.475-81.538 0-29.883 4.858-57.337 14.575-82.363 9.717-25.024 23.375-46.612 40.975-64.762s38.683-32.267 63.25-42.35c24.567-10.083 51.608-15.125 81.125-15.125 15.033 0 29.196 1.329 42.487 3.987 13.292 2.658 25.713 6.325 37.263 11 11.55 4.675 22.183 10.313 31.9 16.913 9.717 6.6 18.333 13.75 25.85 21.45l-31.35 42.075c-2.017 2.567-4.4 4.904-7.15 7.012-2.75 2.109-6.6 3.163-11.55 3.163-3.3 0-6.417-.733-9.35-2.2-2.933-1.466-6.05-3.255-9.35-5.363a1772.26 1772.26 0 0 0-10.862-6.875c-3.942-2.475-8.617-4.767-14.026-6.875-5.408-2.107-11.733-3.895-18.974-5.362-7.242-1.467-15.721-2.2-25.438-2.2-15.4 0-29.471 2.841-42.213 8.525-12.741 5.684-23.741 13.979-33 24.888-9.258 10.908-16.408 24.291-21.449 40.149-5.042 15.858-7.563 33.963-7.563 54.313 0 20.534 2.796 38.775 8.387 54.725 5.592 15.95 13.2 29.379 22.825 40.287 9.625 10.908 20.855 19.204 33.688 24.888 12.833 5.684 26.583 8.525 41.25 8.525 8.434 0 16.133-.413 23.1-1.238 6.967-.824 13.475-2.199 19.525-4.125 6.05-1.925 11.733-4.491 17.05-7.699 5.317-3.209 10.725-7.288 16.225-12.238a32.536 32.536 0 0 1 7.15-4.538c2.567-1.191 5.225-1.787 7.975-1.787Z"
                            fill-rule="evenodd"></path>
                        </g>
                      </svg>
                    </i>
                  </button>
                  <!-- Roman -->
                  <button class="font-text-btn" title="roman-list" nz-button [disabled]="config['curve']['isCurve']"
                    (click)="handleListStyle('upper-roman')" [nzType]="
                    class['quantity-sold__content--list-style']['list-style'] === 'upper-roman inside none'
                      ? 'primary'
                      : 'default'">
                    <i class="anticon anticon-ordered-list">
                      <svg fill="currentColor" width="1em" height="1em" viewBox="0 0 1920 1920"
                        xmlns="http://www.w3.org/2000/svg">
                        <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                        <g id="SVGRepo_iconCarrier">
                          <path
                            d="m368 585.675h93.5v-400.675h-93.5zm271-101h1280v-120h-1280zm-270.725 700h93.5v-400.675h-93.5zm-185.05 0h93.5v-400.675h-93.5zm455.775-139h1280v-120.001h-1280zm-270.775 689h93.5v-400.676h-93.5zm-184 0h93.5v-400.676h-93.5zm-183.225 0h93.5v-400.676h-93.5v400.676zm638-129h1280v-120h-1280z"
                            fill-rule="evenodd"></path>
                        </g>
                      </svg>
                    </i>
                  </button>
                </div>
              </div>
            </div>
            <div class="field-row">
              <div class="config-font" style="margin-top:20px">
                <!-- Khoảng cách chữ -->
                <div class="font-text-letterspacing">
                  <div class="config-name" style="gap:5px">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_chu' | translate }}</p>
                    <nz-input-number [nzMin]="0" [nzMax]="50" [ngStyle]="{ width: '40%' }"
                      [ngModel]="class['quantity-sold__content']['letter-spacing'] | vhnumber" (nzBlur)="updateClass()"
                      (ngModelChange)="class['quantity-sold__content']['letter-spacing'] = $event +'px'">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0" [nzMax]="50"
                        [ngModel]="class['quantity-sold__content']['letter-spacing'] | vhnumber"
                        (nzOnAfterChange)="updateClass();"
                        (ngModelChange)="class['quantity-sold__content']['letter-spacing'] = $event +'px'">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Khoảng cách dòng -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">{{ 'khoang_cach_dong' | translate }}</p>
                    <nz-input-number [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="this.class['quantity-sold__content']['line-height']" (nzBlur)="updateClass()"
                      [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [nzMin]="0.5" [nzMax]="3" [nzStep]="0.1"
                        [(ngModel)]="this.class['quantity-sold__content']['line-height']"
                        (nzOnAfterChange)="updateClass()">
                      </nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <!-- Độ nghiêng chữ -->
                <div class="font-text-linespacing">
                  <div class="config-name">
                    <p class="m-0" style="line-height:1.5">Độ nghiêng chữ</p>
                    <nz-input-number [nzMin]="0" [nzMax]="360" [nzStep]="1" [ngStyle]="{ width: '40%' }"
                      [(ngModel)]="config['transform']['rotate']" (nzBlur)="handleSetTextRotate()">
                    </nz-input-number>
                  </div>
                  <nz-row>
                    <nz-col nzSpan="24">
                      <nz-slider [(ngModel)]="config['transform']['rotate']" (nzOnAfterChange)="handleSetTextRotate()"
                        [nzMin]="0" [nzMax]="360" [nzStep]="1"></nz-slider>
                    </nz-col>
                  </nz-row>
                </div>
                <ng-container *ngIf="config['transform']['rotate'] > 0">
                  <!-- Ẩn chữ -->
                  <div>
                    <div class="config-name mb-0">
                      <p>{{'an_chu' | translate}}</p>
                      <nz-switch [ngModel]="class.text.overflow == 'hidden'"
                      (ngModelChange)="class.text.overflow = $event ? 'hidden' : 'visible'; updateClass()">
                      </nz-switch>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
            <div class="field-row" *ngIf="config['font-size']['title'] == 'Blockquote'">
              <!-- Blockquote - Thụt lề -->
              <div class="config-font">
                <div class="quote-row">
                  <p class="text-indent">Thụt lề</p>
                  <nz-input-number [nzMin]="1" [nzMax]="100" [ngStyle]="{ width: '40%' }"
                    [ngModel]="class['quantity-sold__content']['padding-left'] | vhnumber" (nzBlur)="updateClass()"
                    (ngModelChange)="class['quantity-sold__content']['padding-left'] = $event +'px'">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="1" [nzMax]="100"
                  [ngModel]="class['quantity-sold__content']['padding-left'] | vhnumber"
                  (nzOnAfterChange)="updateClass();"
                  (ngModelChange)="class['quantity-sold__content']['padding-left'] = $event +'px'">
                </nz-slider>
              </div>
              <!-- Blockquote - Kích thước viền -->
              <div class="config-font">
                <div class="quote-row">
                  <p class="text-indent" style="line-height:1.5">Kích thước viền: </p>
                  <nz-input-number [nzMin]="1" [nzMax]="20" [ngStyle]="{ width: '40%' }"
                    [ngModel]="class['quantity-sold__content']['border-left-width'] | vhnumber" (nzBlur)="updateClass()"
                    (ngModelChange)="class['quantity-sold__content']['border-left-width'] = $event +'px'">
                  </nz-input-number>
                </div>
                <nz-slider [nzMin]="1" [nzMax]="100"
                  [ngModel]="class['quantity-sold__content']['border-left-width'] | vhnumber"
                  (nzOnAfterChange)="updateClass();"
                  (ngModelChange)="class['quantity-sold__content']['border-left-width'] = $event +'px'">
                </nz-slider>
              </div>
              <div class="config-font">
                <div class="quote-row">
                  <p class="text-indent">Màu viền: </p>
                  <input type="color" class="quote-color"
                    [(ngModel)]="class['quantity-sold__content']['border-left-color']" (blur)="updateClass()" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <!-- PHONG CÁCH VÀ KIỂU CỌ -->
      <li nz-submenu nzTitle="{{'phong_cach_va_kieu_co' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
        <app-text-style-config
                [config]="config"
                [class]="class"
                [staticdata]="staticdata"
                [device]="device"
                [objectChoosing]="objectChoosing"
                [textContentClass]="class['quantity-sold__content']"
                [textWrapperClass]="class['quantity-sold']"
                [filterConfig]="config['text-shadow']"
                [curveConfig]="config['curve']"
                [textCurveItemClass]="class['quantity-sold__content--curve-item']"
                [textCurveClass]="class['quantity-sold__content--curve']"
                [isShape]="true"
        >
        </app-text-style-config>
      </li>
      <!-- HIỆU ỨNG -->
      <li nz-submenu nzTitle="{{'hieu_ung' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
        <app-choose-animations-config [type]="type" [elementChoosing]="objectChoosing" (openAnimationDetail)="openAnimationDetail($event)"
          [id_object]="objectChoosing._id" [device]="device" [class]="class" [config]="config" [staticdata]="staticdata"
          [cursorClass]="class['quantity-sold']" [effect_hover]="effect_hover" [customize]="customize" [type]="'object'">
        </app-choose-animations-config>
      </li>
    </ul>
  </ng-container>

  <!-- CẤU HÌNH CHI TIẾT -->
  <div class="view-more" *ngIf="isViewAll">
    <!-- Cấu hình chi tiết hiệu ứng -->
    <div class="editor_effect-hover" *ngIf="this.config['animation-selected'].id != '000000'">
       <app-animations-config [type]="type" [elementChoosing]="objectChoosing" [staticdata]="staticdata" [staticdata]="staticdata" [id_object]="objectChoosing._id"
        [customize]="customize"></app-animations-config>
    </div>
  </div>
</div>